import BotMart from '../pages-dynamic/botmart';
import CopSupply from '../pages-dynamic/copsupply';
import axios from 'axios';
import React, { useEffect } from 'react';
import styled from 'styled-components';
// import Features from '../components/landing/features';
import Hero from '../components/landing/hero';
import TrendingReleases from '../components/landing/trending-releases';
import { analytics } from '../lib/analytics';
import { motion } from 'framer-motion';
import { useQuery } from '@apollo/client';
import { TRENDING_BOTS } from '@/lib/graphql/queries';
import { addApolloState, initializeApollo } from '@/lib/apollo';

const LandingWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  @media only screen and (max-width: 972px) {
    overflow: hidden;
  }
`;

const Landing = (props) => {
  const {
    data: { trendingBots },
  } = useQuery(TRENDING_BOTS, {
    variables: {
      limit: 3,
    },
  });

  useEffect(() => {
    analytics.page('Home');
  }, []);

  return (
    <LandingWrapper>
      <motion.div
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Hero trendingBots={trendingBots} />
        <TrendingReleases upcomingReleases={props.upcomingReleases} />
      </motion.div>
      {/* <Features /> */}
    </LandingWrapper>
  );
};

let app;

switch (process.env.WHITE_LABEL_ORG) {
  case 'botmart':
    app = BotMart;
    break;
  case 'copsupply':
    app = CopSupply;
    break;
  default:
    app = Landing;
    break;
}
export default app;

export async function getStaticProps() {
  if (['botmart', 'copsupply'].includes(process.env.WHITE_LABEL_ORG)) {
    return {
      props: {},
    };
  }

  let upcomingReleases = [];
  try {
    upcomingReleases = (
      await axios.get(
        `${process.env.BACKEND_URI}/releases/upcoming?category=sneakers&limit=3`,
      )
    ).data;
  } catch (error) {
    console.error(error);
    upcomingReleases = [];
  }

  const apolloClient = initializeApollo();

  await apolloClient.query({
    query: TRENDING_BOTS,
    variables: {
      limit: 3,
    },
  });

  return addApolloState(apolloClient, {
    props: {
      upcomingReleases,
    },
    revalidate: 3600,
  });
}
